__turbopack_context__.v({
  "search_pagination_list_item_button": "SearchPaginationItem-module-scss-module__hRQghG__search_pagination_list_item_button",
  "search_pagination_list_item_button_selected": "SearchPaginationItem-module-scss-module__hRQghG__search_pagination_list_item_button_selected",
});
